@if (pageInfo?.["title"] != "Analytical" && pageInfo?.["title"] != "eCommerce") {
  <div class="bg-light-primary rounded p-y-16 p-x-24 m-b-30 overflow-hidden center">
    <div class="row">
      <div class="col-sm-8">
        <!-- <h4 class="page-title m-0 f-s-16 f-w-600 ">
        {{ pageInfo?.['title'] | translate}}
      </h4> -->
        <nav class="d-flex align-items-center flex-wrap gap-1">
          @if (pageInfo?.["title"]?.includes(" / ")) {
            @for (segment of pageInfo?.["title"]?.split(" / "); track segment; let last = $last) {
              <span
                [style.color]="last ? '#000000' : '#64748B'"
                [style.font-weight]="last ? '600' : '400'"
                class="f-s-14"
              >
                {{ segment }}
              </span>
              @if (!last) {
                <span style="color: #64748b; padding: 0 6px" class="f-s-14">/</span>
              }
            }
          } @else {
            <span style="color: #000000; font-weight: 600" class="f-s-14">
              {{ pageInfo?.["title"] | translate }}
            </span>
          }
        </nav>
      </div>
    </div>
  </div>
}
